// import { graphql, useStaticQuery, Link } from "gatsby";
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Transition, Menu } from '@headlessui/react'
import { Link, navigate } from 'gatsby'
import UXDXLogo from 'src/images/uxdx-logo.svg'
import { useAuthService } from 'theme/services/auth/auth-service'
import { getEventLink, getConferenceLocation } from 'theme/utils/generic-helpers'
import { startAndEndDate } from 'src/utils/date-helpers'
import { MainMenu } from '../mainMenu2'
import CookieConsentBanner from 'src/components/CookieConsentBanner'

function Header({ conferences }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const authService = useAuthService()
  const user = authService.user
  const authenticated = authService.authenticated

  const handleSignOut = (e) => {
    e.preventDefault()
    authService.logout()
    navigate('/')
  }

  return (
    <>
    <CookieConsentBanner />
      <nav
        data-cy="navbar"
        className="fixed bg-uxdx-700 sm:bg-gradient-to-r sm:from-uxdx-700 sm:via-sky-500 sm:to-sky-700 w-full z-20"
      >
        <MainMenu />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0 ">
                <Link to="/">
                  <img
                    className="h-10 w-10"
                    src={UXDXLogo}
                    alt="
                  UXDX logo"
                  />
                </Link>
              </div>
              <div className="mx-auto pl-2 pr-4 sm:pr-6 lg:pr-0 xl:pr-8 md:hidden">
                <Link to="/conferences">
                  <p className="ml-2 text-lg font-bold text-white">Conferences</p>
                </Link>
              </div>
              <div className="mx-auto pl-2 pr-4 sm:pr-6 lg:pr-0 xl:pr-8 hidden sm:block md:hidden lg:block">
                <div className="flex">
                  {conferences.nodes &&
                    conferences.nodes.map((conf, i) => {
                      return (
                        <div key={conf.data.Conference_Id} className="flex">
                          <Link
                            to={getEventLink(conf.data.Conference_Id, getConferenceLocation(conf))}
                            className="mr-2 sm:mr-4 my-2 sm:px-3 py-2 ml-2 sm:ml-4  rounded-md text-lg text-center font-medium leading-5 text-gray-100 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
                          >
                            {conf.data.Conference_Name}
                            <br />
                            <span className="text-sm text-gray-100 italic">
                              {startAndEndDate(
                                conf.data.Conference_Start_Date,
                                conf.data.Conference_End_Date,
                                'UTC',
                              )}
                            </span>
                          </Link>
                          <div
                            className={`${
                              i === conferences.nodes.length - 1 ? 'hidden' : ''
                            } border-l-2 border-white my-4`}
                          />
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-2 flex items-middle itemc-center xl:space-x-4">
                <Link
                  to="/partner/"
                  className="inline-flex justify-center w-full px-4 py-2 text-md uppercase font-medium leading-5 transition duration-150 ease-in-out rounded-md text-white border border-white hover:text-gray-100 hover:bg-blueGray-700 focus:outline-none focus:text-blueGray-700 focus:bg-white"
                >
                  Partner
                </Link>

                <div className="flex items-center justify-center">
                  <div className="inline-block text-left ml-2">
                    <Menu>
                      {({ open }) => (
                        <>
                          <span className="rounded-md">
                            <Menu.Button
                              id="tickets-link"
                              className="inline-flex justify-center w-full px-4 py-2 text-md uppercase font-medium leading-5 transition duration-150 ease-in-out rounded-md bg-white text-gray-700 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-gray-700 focus:bg-white"
                            >
                              <span>Tickets</span>
                              <svg className="w-5 h-5 ml-2 -mr-1" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                  fillRule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </Menu.Button>
                          </span>
                          <Transition
                            show={open}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items
                              static
                              className="absolute z-10 right-0 w-96 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none"
                            >
                              <div className="py-1">
                                {conferences.nodes &&
                                  conferences.nodes.map((conf) => {
                                    return (
                                      <Menu.Item key={conf.data.Conference_Id}>
                                        {({ active }) => (
                                          <Link
                                            to={getEventLink(
                                              conf.data.Conference_Id,
                                              getConferenceLocation(conf),
                                              'tickets',
                                            )}
                                            className={`${
                                              active ? 'bg-gray-50 ' : ''
                                            } m-2 px-4 py-4 flex items-start space-x-4 rounded-lg`}
                                          >
                                            <svg
                                              className="flex-shrink-0 h-6 w-6 text-uxdx-600"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke="currentColor"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                              />
                                            </svg>
                                            <div className="space-y-1">
                                              <p className="text-base leading-6 font-medium text-gray-900">
                                                {conf.data.Conference_Name} Tickets
                                              </p>
                                              <p className="text-sm leading-5 text-gray-500">
                                                {startAndEndDate(
                                                  conf.data.Conference_Start_Date,
                                                  conf.data.Conference_End_Date,
                                                )}
                                                <br />
                                                {conf.data.Menu_Link_Overview}
                                              </p>
                                            </div>
                                          </Link>
                                        )}
                                      </Menu.Item>
                                    )
                                  })}
                                <Menu.Item>
                                  {({ active }) => (
                                    <Link
                                      to="/community/"
                                      className={`${
                                        active ? 'bg-gray-50' : ''
                                      } m-2 px-4 py-4 flex items-start space-x-4 rounded-lg`}
                                    >
                                      <svg
                                        className="flex-shrink-0 h-6 w-6 text-uxdx-600"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                        />
                                      </svg>
                                      <div className="space-y-1">
                                        <p className="text-base leading-6 font-medium text-gray-900">
                                          UXDX Community
                                        </p>
                                        <p className="text-sm leading-5 text-gray-500">
                                          Smaller gatherings of Product, UX, Design and Dev teams around the
                                          world, by the community, for the community.
                                        </p>
                                      </div>
                                    </Link>
                                  )}
                                </Menu.Item>
                              </div>
                            </Menu.Items>
                          </Transition>
                        </>
                      )}
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
            <div className="-mr-2 flex md:hidden">
              {/* <!-- Mobile menu button --> */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-100 hover:text-gray-700 hover:bg-white focus:outline-none focus:bg-white focus:text-gray-700"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className={`${mobileMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <svg
                  className={`${mobileMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* <!--
        Mobile menu, toggle classes based on menu state.
        Open: "block", closed: "hidden"
      --> */}
        <div className={`${mobileMenuOpen ? 'block' : 'hidden'} md:hidden overflow-auto`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {/* CONFERENCES */}
            <p className="border-b-2 border-white uppercase text-white px-2 pt-5 py-1">Conferences</p>
            {conferences.nodes &&
              conferences.nodes.map((conf) => {
                return (
                  <Link
                    key={conf.data.Conference_Id}
                    to={getEventLink(conf.data.Conference_Id, getConferenceLocation(conf))}
                    className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
                  >
                    {conf.data.Conference_Name}{' '}
                    <span className="text-sm text-gray-100">
                      {startAndEndDate(conf.data.Conference_Start_Date, conf.data.Conference_End_Date)}
                    </span>
                  </Link>
                )
              })}

            <Link
              to="/partner/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white"
            >
              Partner with Us
            </Link>
            <Link
              to="/conferences/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white"
            >
              Past Conferences
            </Link>

            {/* COMMUNITY */}
            {/* <p className='border-b-2 border-white uppercase text-white px-2 pt-5 py-1'>Community</p> */}
            <Link
              to="/community/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white"
            >
              UXDX Community Events
            </Link>
            {/* <Link to='/slack' className='block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white'>
              Join our Slack Channel
            </Link>
            <Link to='/community' className='block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white'>
              Become a Community Leader
            </Link> */}

            <p className="border-b-2 border-white uppercase text-white px-2 pt-5 py-1">Content</p>
            <Link
              to="/knowledge/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
            >
              Knowledge Center
            </Link>

            <Link
              to="/model/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white"
            >
              UXDX Model
            </Link>

            {/* <Link to='/blog' className='block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white'>
              Blog
            </Link> */}

            <p className="pt-5 border-b-2 border-white uppercase text-white px-2 py-1">Jobs</p>
            <Link
              to="/jobs/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
            >
              Jobs Board
            </Link>

            {/* <Link to='/speak' className='block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white'>
              Speak
            </Link>
            <Link to='/media' className='block px-3 py-2 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white'>
              Media
            </Link> */}

            {/* <Link to='/leader' className='block px-3 py-2 pb-4 rounded-md text-base font-medium text-white  focus:outline-none focus:text-gray-700 focus:bg-white'>
              Community Leader
            </Link> */}
          </div>

          <div className="mt-4 pt-4 pb-3 ml-2 mr-2 border-t border-white">
            {/* If not signed In */}
            <span className={`${authenticated ? 'hidden' : 'block'} px-2 pt-2 pb-3 space-y-1 sm:px-3`}>
              <Link
                data-cy="header-login-link"
                to="/login/"
                className="block px-3 py-2 rounded-md text-white font-medium text-base bg-gray-700 focus:outline-none focus:text-white"
              >
                Sign In
              </Link>
            </span>
            {/* If signed In */}
            <div className={`${authenticated ? 'block' : 'hidden'} `}>
              <div className="flex items-center px-5 space-x-3">
                <div className="space-y-1">
                  <div className="text-base font-medium leading-none text-white">
                    {user && (
                      <>
                        {user.firstName} {user.lastName}
                      </>
                    )}
                  </div>
                  <div className="text-sm font-medium leading-none text-gray-200">{user && user.email}</div>
                </div>
              </div>
              <div
                className="mt-3 px-2 space-y-1"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
              >
                <Link
                  to="/account/"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-100 focus:outline-none focus:text-white"
                  role="menuitem"
                >
                  Your Profile
                </Link>

                <div
                  onClick={handleSignOut}
                  data-cy="header-logout-link"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-100 focus:outline-none focus:text-white"
                  role="menuitem"
                >
                  Sign out
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

Header.propTypes = {
  conferences: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.shape({
          Conference_Id: PropTypes.string.isRequired,
          Conference_Name: PropTypes.string.isRequired,
          Type: PropTypes.string.isRequired,
          Location: PropTypes.string.isRequired,
          Conference_Venue_Type: PropTypes.arrayOf(PropTypes.string.isRequired),
          Conference_Start_Date: PropTypes.string.isRequired,
          Conference_End_Date: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
}

export default Header
